<template>
  <div
    class="d-flex flex-column container"
    :class="$vuetify.breakpoint.mobile ? 'mt-4' : 'mt-12'"
    :style="`max-width: ${$vuetify.breakpoint.mobile ? 100 : 80}%;`"
  >
    <img
      v-if="$vuetify.breakpoint.mobile"
      src="./OXE - JDO 998x1810 V2.png"
      :style="`height: ${$vuetify.breakpoint.mobile ? 90 : 90}vh`"
    />

    <img
      v-else
      src="./OXE - JDO 1816 x1000 V2.png"
      alt="imagem"
      :style="`height: ${$vuetify.breakpoint.mobile ? 85 : 85}vh`"
    />

    <div class="d-flex justify-center">
      <v-btn
        class="oxebet-button"
        rounded
        large
        href="https://www.jogodeouro.bet/home?sport=Futebol&amp;live=Futebol"
      >
        MIGRE AGORA SEUS DADOS
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnMigration",
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.oxebet-button {
  margin-top: -150px;
  background-color: #2d217e !important;
  border: 3px solid #017efb !important;
  color: #fff;
  width: 300px !important;
  border-radius: 30px;
  font-size: 1em;
  padding: 2em !important;
  font-weight: bolder;
}
</style>
